module.exports = __webpack_public_path__ + "img/2272cb9.jpg";